export default __webpack_public_path__ + "static/media/development.ee5a59de.png";